const userDetailsreducer = (
  state = {
    username: null,
    token: null,
    expiresIn: "",
  },
  action
) => {
  switch (action.type) {
    case "ADD_USER_DETAIL": {
      const { token, username } = action.payload;
      const userDetails = {
        token,
        username,
        expiresIn: new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
      };
      window.localStorage.setItem("userDetails", JSON.stringify(userDetails));
      return userDetails;
    }
    case "ADD_USER_DETAILS_FROM_LOCALSTORAGE": {
      const { username, expiresIn } = action.payload;
      let expire = new Date(expiresIn);
      let current = new Date();
      if (username === undefined) {
        return state;
      }
      if (current < expire) {
        return action.payload;
      } else {
        window.localStorage.clear();
        return state;
      }
    }
    case "LOG_OUT_USER": {
      window.localStorage.clear();
      return { username: null, token: null, expiresIn: "" };
    }
    default: {
      return state;
    }
  }
};

export default userDetailsreducer;
